(function ($, ns, _) {
  'use strict';

  var cfg = {
    cache: {
      productContainer: '.product-overview-container',
      productCount: '.product-overview-result-count',
      filterContainer: '.product-filters',
      filterTheme: '.product-filters-theme',
      filterCategory: '.product-filters-category',
      filterSubCategory: '.product-filters-subcategory',
      filterCategoryActive: '.product-filters-active',
      filterThemesContainer: '.product-filters-themes',
      filterCategoryContainer: '.product-filters-main-container',
      filterSubCategoryContainer: '.product-filters-sub-container',
      productFiltersContainer: '.product-filters-container',
      filterPartContainer: '.product-filters-part-container',
      mobileFilterPartTitle: '.product-filters-part-title',
      filterIntroCategory: '.product-filters-body-intro',
      ellipsis: '.ellipsis',
      filterIntroSubCategory: '.product-filters-body-intro-subcategory',
      productItemTemplate: 'template.product-item',
      noResultsTemplate: 'template.product-overview-no-results',
      badResultsTemplate: 'template.product-overview-bad-results',
      filterCategoryGroupTemplate: 'template.filter-category-group',
      filterCategoryTemplate: 'template.filter-category',
      filterSubCategoryTemplate: 'template.filter-subcategory',
      filterTemplate: 'template.filter-filter',
      filterCheckboxTemplate: 'template.filter-filter-checkbox',
      filterSliderTemplate: 'template.filter-filter-slider',
      filterSearch: '.product-filters-search',
      filterBody: '.product-filters-filter-body',
      filterCheckbox: '.product-filters-filter .form-group.checkbox',
      filterSlider: '.product-filters-filter .slider',
      filterSliderInput: 'input.bootstrap-slider',
      filterSliderMin: '.filter-filter-slider-min',
      filterSliderMax: '.filter-filter-slider-max',
      input: 'input',
      btnClearFilter: '.btn-clear-filter',
      btnLoadMore: '.btn-more',
      btnDismiss: '.btn-dismiss, .btn-show-results',
      filterPopupOpenToggle: '.btn-filter-popup-toggle-open',
      checked: ':checked',
      mobileProductFiltersTitle: '.product-filters-filter-title',
      productOverviewMainWrapper: '.product-overview-section',
      productOverviewFooterSiblingTemplate: 'template.product-overview-footer-sibling',
      mobileProductFiltersTitle: '.product-filters-filter-title',
      productCategoriesPlaceholder: '.product-categories-placeholder',
      productOverviewHeader: '.product-overview-header',
      productOverviewHeaderTitle: '.product-overview-header-title',
      productOverviewHeaderIntro: '.product-overview-header-intro-wrapper',
      productOverviewFooterDescription: '.product-overview-footer-description',
      productOverviewFooterSiblings: '.product-overview-footer-siblings-wrapper',
      productOverviewFooterSibling: '.product-overview-footer-sibling',
      productOverviewFooterSiblingsTitle: '.product-overview-footer-siblings-title',
      productOverviewHeaderBtnMore: '.product-overview-header-btn-more',
      filtersSortOptions: '.product-filters-sort-options',
      breadcrumbItemCategory: 'template.breadcrumb-item',
      breadCrumb: '.breadcrumb',
      categorySection: '.category-section',
      categoryImage: '.category-information-image img',
      categoryTitle: '.category-information-title',
      categoryDescription: '.category-information-description',
      sitecoreForm: 'form[data-ajax]',
    },
    data: {
      apiUrl: 'api-url',
      baseUrl: 'base-url',
      siteGroup: 'sitegroup',
      language: 'language',
      pageSize: 'page-size',
      selected: 'selected',
      value: 'value',
      themeValue: 'theme-value',
      collapsetext: 'collapsetext',
      datasourceId: 'datasource-id',
      acceptheader: 'acceptheader',


      formScripts: [
        '/sitecore%20modules/Web/ExperienceForms/scripts/jquery-3.4.1.min.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/jquery.validate.min.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/jquery.validate.unobtrusive.min.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/jquery.unobtrusive-ajax.min.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/form.validate.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/form.tracking.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/form.conditions.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/formsextensions.ajax.js',
        '/sitecore%20modules/Web/ExperienceForms/scripts/formsextensions.validate.js',
      ],
    },
    templates: {},
    classes: {
      hidden: 'hidden',
      loading: 'loading',
      productFiltersCategoryCollapsed: 'product-filters-category-collapsed',
      contact: 'footer-contact',
      clear: 'filter-clear',
      search: 'header-search',
      mobileHide: 'mobile-hide',
      productFiltersMany: 'product-filters-many',
      isOpen: 'is-open',
      hasImage: 'has-image',
    },
    events: {
      click: 'click',
      change: 'change',
      slide: 'slide',
    },
  };

  ns.ProductOverview = function (container) {
    this.settings = cfg;

    this.container = container;
    this.init();
  };

  ns.ProductOverview.prototype = {
    init: function () {
      this.cacheItems();
      this.bindEvents();
      this.activate();
    },
    cacheItems: function () {
      let settings = this.settings,
        cache = settings.cache,
        data = settings.data,
        templates = settings.templates;

      this.htmlBody = $('html, body');

      // Elements
      this.productCount = this.container.find(cache.productCount);
      this.productContainer = this.container.find(cache.productContainer);
      this.productOverviewMainWrapper = this.container.find(cache.productOverviewMainWrapper);
      this.productOverviewHeader = this.container.find(cache.productOverviewHeader);
      this.btnLoadMore = this.container.find(cache.btnLoadMore);
      this.filterContainer = this.container.find(cache.filterContainer);
      this.filterThemesContainer = this.container.find(cache.filterThemesContainer);

      this.filterCategoryContainer = this.container.find(cache.filterCategoryContainer);
      this.filterSubCategoryContainer = this.container.find(cache.filterSubCategoryContainer);
      this.filterPartContainer = this.container.find(cache.filterPartContainer);
      this.productFiltersContainer = this.container.find(cache.productFiltersContainer);

      this.btnClearFilter = this.container.find(cache.btnClearFilter);
      this.filterIntroCategory = this.container.find(cache.filterIntroCategory);
      this.filterIntroCategoryEllipsis = this.filterIntroCategory.find(cache.ellipsis);
      this.filterIntroSubCategory = this.container.find(cache.filterIntroSubCategory);
      this.filterIntroSubCategoryEllipsis = this.filterIntroSubCategory.find(cache.ellipsis);
      this.filterActiveCategory = this.container.find(cache.filterCategoryActive).first();
      this.filterActiveSubCategory = this.container.find(cache.filterCategoryActive).last();

      this.mobileBtnSelectCategories = this.container.find(cache.mobileBtnSelectCategories);
      this.mobileBtnSelectSubcategories = this.container.find(cache.mobileBtnSelectSubcategories);
      this.mobileFilterPartTitle = this.container.find(cache.mobileFilterPartTitle);

      this.filterPopupOpen = this.container.find(cache.filterPopupOpenToggle);
      this.filterPopupDismiss = this.productFiltersContainer.find(cache.btnDismiss);

      this.productOverviewHeaderTitle = this.container.find(cache.productOverviewHeaderTitle);
      this.productOverviewHeaderIntro = this.container.find(cache.productOverviewHeaderIntro);
      this.productOverviewFooterDescription = this.container.find(cache.productOverviewFooterDescription);
      this.productOverviewFooterSiblings = this.container.find(cache.productOverviewFooterSiblings);
      this.productOverviewFooterSiblingsTitle = this.container.find(cache.productOverviewFooterSiblingsTitle);
      this.productOverviewHeaderBtnMore = this.container.find(cache.productOverviewHeaderBtnMore);
      this.productCategoriesPlaceholder = this.container.find(cache.productCategoriesPlaceholder);
      this.filtersSortOptions = this.container.find(cache.filtersSortOptions);

      this.breadcrumb = this.container.find(cache.breadCrumb);
      this.categorySection = this.container.find(cache.categorySection);
      this.categoryTitle = this.container.find(cache.categoryTitle);
      this.categoryDescription = this.container.find(cache.categoryDescription);
      this.categoryImage = this.container.find(cache.categoryImage);

      // Templates
      templates.productItemTemplate = this.productContainer.find(cache.productItemTemplate).html();
      templates.noResultsTemplate = this.productContainer.find(cache.noResultsTemplate).html();
      templates.badResultsTemplate = this.productContainer.find(cache.badResultsTemplate).html();
      templates.filterCategoryGroupTemplate = this.filterCategoryContainer.find(cache.filterCategoryGroupTemplate).html();
      templates.filterCategoryTemplate = this.filterCategoryContainer.find(cache.filterCategoryTemplate).html();
      templates.filterSubCategoryTemplate = this.filterCategoryContainer.find(cache.filterSubCategoryTemplate).html();
      templates.filterTemplate = this.filterCategoryContainer.find(cache.filterTemplate).html();
      templates.filterCheckboxTemplate = this.filterCategoryContainer.find(cache.filterCheckboxTemplate).html();
      templates.filterSliderTemplate = this.filterCategoryContainer.find(cache.filterSliderTemplate).html();
      templates.productOverviewFooterSiblingTemplate = this.productOverviewFooterSiblings.find(cache.productOverviewFooterSiblingTemplate).html();

      templates.breadCrumbItemTemplate = this.filterCategoryContainer.find(cache.breadcrumbItemCategory).html();

      // Data cache
      this.apiUrl = this.container.data(data.apiUrl);
      this.baseUrl = this.container.data(data.baseUrl);
      this.siteGroup = this.container.data(data.siteGroup);
      this.language = this.container.data(data.language);
      this.pageSize = this.container.data(data.pageSize);
      this.datasourceId = this.container.data(data.datasourceId);
      this.acceptheader = this.container.data(data.acceptheader);
    },
    bindEvents: function () {
      let settings = this.settings,
        cache = settings.cache,
        data = settings.data,
        events = settings.events,
        classes = settings.classes;

      this.filterThemesContainer.on(events.click, cache.filterTheme, (e) => {
        let currentState = $(e.currentTarget).attr('data-' + data.selected) === 'true';

        this.filterThemesContainer.find(cache.filterTheme).attr('data-' + data.selected, false);

        $(e.currentTarget).attr('data-' + data.selected, !currentState);

        this.setCategoryOne('', '');
        this.setCategoryTwo('', '');
        this.filterCategoryContainer.html('');
        this.filterSubCategoryContainer.html('');
        this.filterPartContainer.html('');

        this.getCurrentThemeStatus();

        this.doUpdate();

        this.cleanHeightCategoryContainer();

        e.preventDefault();
        return false;
      });

      this.filterCategoryContainer.on(events.click, cache.filterCategory, (e) => {
        let currentState = $(e.currentTarget).attr('data-' + data.selected) === 'true';
        // Not selected, will become selected
        if (!currentState) {
          this.filterCategoryContainer.find(cache.filterCategory).attr('data-' + data.selected, false);
        }
        $(e.currentTarget).attr('data-' + data.selected, !currentState);

        this.getCurrentCategoryOneStatus();

        if (!this.isMobileSelectionActive) {
          this.doUpdate();
        }

        e.preventDefault();

        // Scroll to top to eliminate being lost at the end of the page while switching to the products
        this.htmlBody.animate({ scrollTop: 0 }, 'slow');

        return false;
      });

      this.filterSubCategoryContainer.on(events.click, cache.filterSubCategory, (e) => {
        let currentState = $(e.currentTarget).attr('data-' + data.selected) === 'true';
        // Not selected, will become selected
        if (!currentState) {
          this.filterSubCategoryContainer.find(cache.filterSubCategory).attr('data-' + data.selected, false);
        }
        $(e.currentTarget).attr('data-' + data.selected, !currentState);

        this.getCurrentCategoryTwoStatus();

        if (!this.isMobileSelectionActive) {
          this.doUpdate();
        }

        e.preventDefault();
        return false;
      });

      this.filterPartContainer.on(
        events.change,
        cache.filterCheckbox,
        _.debounce(() => {
          this.getFilterStatus();
          this.doUpdate();
        }, 300)
      );

      this.filterPartContainer.on(
        events.change,
        cache.filterSlider,
        _.debounce(() => {
          this.getFilterStatus();
          this.doUpdate();
        }, 300)
      );

      this.filterActiveCategory.on(events.click, () => {
        this.setCategoryOne('', '');
        this.setCategoryTwo('', '');
        this.selectedFilters = [];
        this.doUpdate();
      });

      this.filterActiveSubCategory.on(events.click, () => {
        this.setCategoryTwo('', '');
        this.selectedFilters = [];
        this.doUpdate();
      });

      this.btnClearFilter.on(events.click, () => {
        this.clearFilterPart();
        this.doUpdate();
        return false;
      });

      this.btnLoadMore.on(events.click, () => {
        this.loadMore();
      });

      this.filterPartContainer.on(events.click, cache.mobileProductFiltersTitle, (e) => {
        let current = $(e.currentTarget);
        let next = current.next();

        next.toggleClass(classes.mobileHide);
        if (next.hasClass(classes.mobileHide)) {
          current.attr('aria-expanded', 'false');
        } else {
          current.attr('aria-expanded', 'true');
        }

        this.persistCollapseState();

        e.preventDefault();
        return false;
      });

      this.filterPopupOpen.on(events.click, () => {
        this.productFiltersContainer.addClass(classes.isOpen);
      });

      this.filterPopupDismiss.on(events.click, () => {
        this.productFiltersContainer.removeClass(classes.isOpen);
      });

      this.productOverviewFooterSiblings.on(events.click, cache.productOverviewFooterSibling, (e) => {
        let newCategory = $(e.currentTarget);
        newCategory.data(data.value);

        if (this.areDisplayedSiblingsLevelOne) {
          this.setCategoryOne(newCategory.data(data.value), newCategory.text());
        } else {
          this.setCategoryTwo(newCategory.data(data.value), newCategory.text());
        }
        this.doUpdate();

        this.htmlBody.animate({ scrollTop: 0 }, 'slow');

        e.preventDefault();
        return false;
      });

      this.filtersSortOptions.on(
        events.change,
        _.debounce(() => {
          //this.getFilterStatus();
          this.doUpdate();
        }, 300)
      );

      window.onpopstate = () => {
        location.reload();
      };
    },
    activate: function () {
      let settings = this.settings,
        cache = settings.cache;

      this.currentPage = 0;
      this.loadedProducts = 0;

      this.selectedThemes = '';
      this.selectedCategoryOne = '';
      this.selectedCategoryTwo = '';

      this.isFiltersDirty = false;
      this.scrollToGroupTechnology = this.getHashFromUrl();

      // Remove slider template because of bad init on ie
      this.filterCategoryContainer.find(cache.filterSliderTemplate).remove();

      let urlParams = this.getUrlParamsFromUrl();
      if (urlParams && urlParams.length) {
        this.getFilterStatusFromUrl(urlParams);
        this.doUpdate(true, true, urlParams);
      } else {
        this.doUpdate();
      }

      this.isMobileSelectionActive = false;
      this.localCache = {};
    },
    getUrlParamsFromUrl: function () {
      let urlParams = window.location.search.split('?');

      if (urlParams.length === 2 && urlParams[1] && urlParams[1].length) {
        this.isFiltersDirty = urlParams[1].indexOf('&filter') !== -1;
        let sortedParams;
        if (urlParams[1].indexOf('sort=') !== -1) {
          sortedParams = urlParams[1];
        } else {
          this.filtersSortOptions.prop('selectedIndex', 0);

          sortedParams = `${urlParams[1]}&sort=${this.filtersSortOptions.val()}`;
        }

        if (urlParams[1].indexOf('page=') == -1) {
          sortedParams += `&page=0`;
        }

        return sortedParams;
      } else {
        return '';
      }
    },
    getFilterStatusFromUrl: function (urlParams) {
      let paramArray = ns.fn.convertUrlParams(urlParams);

      this.selectedThemes = paramArray.theme;
      this.selectedCategoryOne = paramArray.category1;
      this.selectedCategoryTwo = paramArray.category2;
      this.currentPage = paramArray.page ? parseInt(paramArray.page) : 0;

      // get all  original filters
      const { category1, category2, page, sort, theme, ...paramFilters } = paramArray;

      const paramFilterKeys = Object.keys(paramFilters);
      let retrievedFilters = {};

      paramFilterKeys.forEach((key, index) => {
        if (key.includes('max') || key.includes('min')) {
          let newKey = key.replaceAll('max', '');
          newKey = newKey.replaceAll('min', '');

          retrievedFilters[newKey] = retrievedFilters[newKey] ? retrievedFilters[newKey] + `,${paramFilters[key]}` : paramFilters[key];
        } else {
          const newKey = key.replaceAll('options', '');
          retrievedFilters[newKey] = paramFilters[key].split(',');
        }
      });

      this.selectedFilters = retrievedFilters;
    },
    getHashFromUrl: function () {
      const currentHash = window.location.hash.substr(1);
      if (currentHash && currentHash !== '') {
        return currentHash;
      } else {
        return false;
      }
    },
    doUpdate: function (isPartialUpdate, isFirstTime = false, urlParams) {
      if (!isPartialUpdate) {
        this.loadedProducts = 0;
        this.currentPage = 0;
      } else {
        this.scrollToGroupTechnology = false;
      }

      this.startLoading();

      let dataPromise = this.getData(urlParams, isFirstTime);
      dataPromise
        .then((data) => {
          let metaPromise = this.processMeta(data);
          let productPromise = this.processProducts(data.Products, isPartialUpdate);
          let filterPromise = this.processFilters(data.Filters);

          const header = $('.deny header, .neu header, .omni header, .antipanic header');

          let fixedHeaderHeight = 0;
          if (header && header.length) {
            fixedHeaderHeight = header.outerHeight();
          } else if ($(window).width() <= 990 && $('.dom header').length) {
            fixedHeaderHeight = $('.dom header').outerHeight();
          }

          Promise.all([productPromise, filterPromise, metaPromise]).then(() => {
            this.toggleShowMore();
            this.endLoading();
          });

          if (this.scrollToGroupTechnology) {
            $('html, body').animate(
              {
                scrollTop: $(`#${this.scrollToGroupTechnology}`).offset().top - fixedHeaderHeight,
              },
              500
            );
          }
          // if already navigated, scroll to latest page
          if (isFirstTime && this.currentPage) {
            $('html, body').animate(
              {
                scrollTop: $(this.productContainer)[0].scrollHeight,
              },
              500
            );
          }
        })
        .catch((error) => {
          this.showError();
          console.error(error);
          this.endLoading();
        });

      return dataPromise;
    },
    buildUrlParams: function () {
      let urlParams = [];

      if (this.selectedThemes && this.selectedThemes.length) {
        urlParams.push('theme=' + this.selectedThemes);
      }

      if (this.selectedCategoryOne && this.selectedCategoryOne.length) {
        urlParams.push('category1=' + this.selectedCategoryOne);
      }

      if (this.selectedCategoryTwo && this.selectedCategoryTwo.length) {
        urlParams.push('category2=' + this.selectedCategoryTwo);
      }

      var selectedFiltersKeys;
      if (this.selectedFilters) {
        selectedFiltersKeys = Object.keys(this.selectedFilters);
      }
      if (this.selectedFilters && selectedFiltersKeys && selectedFiltersKeys.length) {
        for (let i = 0; i < selectedFiltersKeys.length; i++) {
          const selectedFilterKey = selectedFiltersKeys[i];
          const selectedFilter = this.selectedFilters[selectedFilterKey];

          if (Array.isArray(selectedFilter)) {
            urlParams.push(`${selectedFilterKey}options=` + selectedFilter.join(`&${selectedFilterKey}options=`));
          } else {
            let filterSliderVals = selectedFilter.split(',');
            urlParams.push(`${selectedFilterKey}min=` + filterSliderVals[0]);
            urlParams.push(`${selectedFilterKey}max=` + filterSliderVals[1]);
          }
        }
      }

      urlParams.push('sort=' + this.filtersSortOptions.val());
      urlParams.push('page=' + this.currentPage);

      if (urlParams.length) {
        urlParams = ns.fn.replaceAll(urlParams.join('&'), ' ', '-').toLowerCase();
      }

      return urlParams;
    },
    getData: function (passedUrlParams, isFirstTime = false) {
      const cPage = isFirstTime ? 0 : this.currentPage;
      let pSize = isFirstTime ? (this.currentPage + 1) * this.pageSize : this.pageSize;

      return new Promise((resolve, reject) => {
        // Build url with params
        let url = this.apiUrl,
          urlParams = [], 
          headers = {};

        if (passedUrlParams && passedUrlParams.length) {
          urlParams = passedUrlParams;
        } else {
          urlParams = this.buildUrlParams();
        }

        if (urlParams.length) {
          url += '?' + urlParams;
        }
        if (this.acceptheader) {
          // Check if the acceptHeader is present and not empty
          headers['Accept'] = this.acceptheader;
        }

        // Check cache if this is the first page and return if there's an entry
        if (this.currentPage === 0 && this.localCache && this.localCache[url]) {
          let data = this.localCache[url];
          this.updateUrl('?' + urlParams, data.BrowserTitle);
          this.filtersData = data.Filters;
          resolve(data);
        } else {
          $.ajax({
            url: url,
            method: 'POST',
            data: {
              sitegroup: this.siteGroup,
              language: this.language,
              page: cPage,
              pageSize: pSize,
              datasourceId: this.datasourceId,
            },
            headers: headers,
            dataType: 'json',
          })
            .done((data) => {
              this.updateUrl('?' + urlParams, data.BrowserTitle);
              this.filtersData = data.Filters;
              resolve(data);
              // When data is returned add this into the cache as well
              if (this.currentPage === 0) {
                this.localCache[url] = data;
              }
            })
            .fail((data) => {
              reject(data);
            });
        }
      });
    },
    processMeta: function (data) {
      return new Promise((resolve) => {
        const settings = this.settings,
          templates = settings.templates,
          classes = settings.classes;

        this.productOverviewHeaderTitle.text(data.HeaderText);
        this.productOverviewHeaderIntro.html(data.TopLongDescription);
        this.productOverviewFooterDescription.html(data.LongDescription);
        this.productOverviewFooterSiblingsTitle.text(data.OtherSubcategoriesLabel);
        this.productOverviewFooterSiblingsTitle.removeClass(classes.hidden);
        this.productOverviewHeaderBtnMore.toggle(!!data.ShowReadWholeDescription);
        this.renderProductCategoriesPlaceholder(data.HtmlComponents);

        let siblingCategories;
        this.areDisplayedSiblingsLevelOne = true;
        if (data.Filters && data.Filters.SubCategories && data.Filters.SubCategories.length && data.Filters.SubCategories.find((x) => x.Selected === true)) {
          siblingCategories = data.Filters.SubCategories;
          this.areDisplayedSiblingsLevelOne = false;
        } else {
          const selectedTheme = data.Filters && data.Filters.Themes ? data.Filters.Themes.find((x) => x.Selected === true) : undefined;

          if (selectedTheme) {
            if (selectedTheme.Categories && selectedTheme.Categories.length) {
              siblingCategories = selectedTheme.Categories;
            } else {
              const selectedTechnology = selectedTheme.Technologies && selectedTheme.Technologies.length ? selectedTheme.Technologies.find((x) => x.Categories && x.Categories.find((y) => y.Selected === true)) : undefined;

              if (selectedTechnology.Categories && selectedTechnology.Categories.length) {
                siblingCategories = selectedTechnology.Categories;
              }
            }
          }
        }

        this.productOverviewFooterSiblings.html('');
        if (siblingCategories) {
          let siblingsHtml = '';

          for (let i = 0; i < siblingCategories.length; i++) {
            if (!siblingCategories[i].Selected) {
              siblingsHtml += ns.fn.renderTemplate(siblingCategories[i], templates.productOverviewFooterSiblingTemplate);
            }
          }
          this.productOverviewFooterSiblings.html(siblingsHtml);
        }

        this.productCount.text(data.Total);
        this.totalProducts = data.Total;

        this.updateBreadcrumb(data.Breadcrumb);
        this.updateIntro(data.HeaderText, data.LongDescription, data.MainImage);

        resolve();
      });
    },
    updateBreadcrumb: function (breadcrumbData) {
      const settings = this.settings,
        templates = settings.templates,
        classes = settings.classes;
      if (breadcrumbData && breadcrumbData.length) {
        $(this.breadcrumb).parents('section').removeClass(classes.hidden);
        let breadcrumbHtml = '';
        const homeIcon = $('<div>').append($(this.breadcrumb).find('li').first().clone()).html();

        breadcrumbHtml += homeIcon;

        for (let i = 0; i < breadcrumbData.length; i++) {
          breadcrumbHtml += ns.fn.renderTemplate(breadcrumbData[i], templates.breadCrumbItemTemplate);
        }

        this.breadcrumb.html(breadcrumbHtml);
      } else {
        $(this.breadcrumb).parents('section').addClass(classes.hidden);
      }
    },

    updateIntro: function (title, description, image) {
      const settings = this.settings,
        classes = settings.classes;

      if (title) {
        this.categoryTitle.html(title);
      }

      if (description) {
        this.categoryDescription.html(description);
      }

      if (image) {
        $(this.categorySection).addClass(classes.hasImage);
        $(this.categoryImage).removeClass(classes.hidden);
      } else {
        $(this.categoryImage).addClass(classes.hidden);
        $(this.categorySection).removeClass(classes.hasImage);
      }

      $(this.categoryDescription).toggleClass(classes.hidden, !description);
      //$(this.categoryImage).attr('src', "http://picard-global-cm.local/global/fr/-/media/DOM/PimDam/jpg/0/001/001.jpg");
      $(this.categoryImage).attr('src', image);
    },

    processFilters: function (filterData) {
      let settings = this.settings,
        templates = settings.templates,
        classes = settings.classes;

      return new Promise((resolve) => {
        if (!filterData) {
          // console.debug('no data found in the filterproperty');
          resolve();
          return;
        }

        // Hide all containers
        this.filterCategoryContainer.hide();
        this.filterSubCategoryContainer.hide();
        this.filterPartContainer.hide();
        this.productOverviewMainWrapper.hide();
        //this.productOverviewHeader.hide();
        this.mobileFilterPartTitle.css('display', '');
        this.container.removeClass(classes.productFiltersMany).removeClass(classes.clear);

        // Hide mobile toggle popup buttons
        this.mobileBtnSelectCategories.hide();
        this.mobileBtnSelectSubcategories.hide();

        // Reset to default state
        this.filterContainer.removeClass(classes.contact).addClass(classes.search);

        // If there is no category selected, render them
        if (!this.selectedCategoryOne || !this.selectedCategoryOne.length) {
          // If no themes data, end the processing
          if (!filterData.Themes || !filterData.Themes.length) {
            console.error('no themes data');
            resolve();
            return;
          }

          this.filterCategoryContainer.html('');
          this.filterCategoryContainer.show();
          this.mobileBtnSelectCategories.css('display', 'block');

          this.filterCategoryContainer.append(this.processCategoryGroups(filterData.Themes));

          resolve();
          return;
        } else {
          let activeFirstCategory;

          let getActiveCategory = () => {
            let findFunction = (x) => {
              return x.Value === this.selectedCategoryOne;
            };

            for (let i = 0; i < filterData.Themes.length; i++) {
              let theme = filterData.Themes[i];
              let themeCat = theme.Categories.find(findFunction);
              if (themeCat) {
                this.selectedThemes = theme.Value;
                return themeCat;
              }

              for (let j = 0; j < theme.Technologies.length; j++) {
                let tech = theme.Technologies[j];
                let techCat = tech.Categories.find(findFunction);
                if (techCat) {
                  this.selectedThemes = theme.Value;
                  return techCat;
                }
              }
            }

            return undefined;
          };

          activeFirstCategory = getActiveCategory();

          if (activeFirstCategory) {
            let activeLabel = activeFirstCategory.Label;
            this.setCategoryOne(this.selectedCategoryOne, activeLabel);
          } else {
            this.setCategoryOne('', '');
            resolve();
            return;
          }

          this.mobileBtnSelectCategories.hide();
        }

        // If there is no subcategory selected and there is no filterdata, render them
        const availableFilters = Object.keys(filterData).filter((x) => x.indexOf('Filter') !== -1);
        if (
          (!this.selectedCategoryTwo || !this.selectedCategoryTwo.length) &&
          (!availableFilters || !availableFilters.length || !filterData[availableFilters[0]] || !filterData[availableFilters[0]].Label || !filterData[availableFilters[0]].Label.length)
        ) {
          // If no subcategories data, end the processing
          if (!filterData.SubCategories || !filterData.SubCategories.length) {
            // console.debug('no data found in the filter Categories property');
            this.filterIntroSubCategory.hide();
            this.productOverviewMainWrapper.show();
            //this.productOverviewHeader.show();
            resolve();
            return;
          }

          this.filterContainer.addClass(classes.contact);

          this.filterIntroSubCategory.show();
          this.filterSubCategoryContainer.show();
          this.mobileBtnSelectSubcategories.css('display', 'block');

          this.filterSubCategoryContainer.html('');
          for (let i = 0; i < filterData.SubCategories.length; i++) {
            this.filterSubCategoryContainer.append(ns.fn.renderTemplate(filterData.SubCategories[i], templates.filterSubCategoryTemplate));
            if (filterData.SubCategories[i].Selected) {
              this.setCategoryTwo(filterData.SubCategories[i].Value, filterData.SubCategories[i].Label, true);

              this.selectedCategoryTwo = filterData.SubCategories[i].Value;
            }
          }

          resolve();
          return;
        } else {
          if (this.selectedCategoryTwo && this.selectedCategoryTwo.length) {
            let activeLabel = this.filtersData.SubCategories.find((x) => x.Value === this.selectedCategoryTwo).Label;
            this.setCategoryTwo(this.selectedCategoryTwo, activeLabel);
          }

          this.filterContainer.removeClass(classes.search);
        }

        // Hide introsubcategory if there is no subcategory data
        if (!filterData.SubCategories || !filterData.SubCategories.length) {
          this.filterIntroSubCategory.hide();
        }

        this.productOverviewMainWrapper.show();
        //this.productOverviewHeader.show();

        const allFilterKeys = Object.keys(filterData);
        const filterKeys = allFilterKeys.filter((x) => x.indexOf('Filter') !== -1);

        if (filterKeys && filterKeys.length) {
          this.filterPartContainer.css('display', 'flex');
          this.filterPartContainer.html('');
          this.mobileFilterPartTitle.css('display', 'block');

          if ((this.selectedFilters && Object.keys(this.selectedFilters).length) || this.isFiltersDirty) {
            this.container.addClass(classes.clear);
          }

          let filterCount = 0;
          for (let i = 0; i < filterKeys.length; i++) {
            const currentFilterKey = filterKeys[i];
            const currentFilter = filterData[currentFilterKey];

            currentFilter.id = currentFilterKey.toLowerCase();
            if (this.processFilterPart(currentFilter, this.selectedFilters ? this.selectedFilters[currentFilter.id] : undefined, this.filterCollapseState === undefined ? false : this.filterCollapseState[0], currentFilterKey + '-')) {
              filterCount++;
            }
          }

          // Toggle multi filter design if more than 2 filters
          this.container.toggleClass(classes.productFiltersMany, filterCount > 2);
        }

        resolve();
      });
    },
    processCategoryGroups: function (themes) {
      let settings = this.settings,
        templates = settings.templates,
        outputString = '';

      for (let j = 0; j < themes.length; j++) {
        let theme = themes[j];
        let categoryGroupItems = '';

        for (let k = 0; k < theme.Technologies.length; k++) {
          let technology = theme.Technologies[k];
          let categoryGroupItems = '';

          for (let l = 0; l < technology.Categories.length; l++) {
            let category = technology.Categories[l];

            categoryGroupItems += this.processCategoryGroupItem(category, theme);
          }
          if (categoryGroupItems.length) {
            outputString += ns.fn.renderTemplate(
              {
                FilterCategoryGroupTheme: theme.Label,
                FilterCategoryGroupTechnology: technology.Label,
                TechnologyUrlHash: technology.UrlHash,
                FitlerCategoryGroupItems: categoryGroupItems,
              },
              templates.filterCategoryGroupTemplate
            );
          }
        }

        for (let i = 0; i < theme.Categories.length; i++) {
          let category = theme.Categories[i];

          categoryGroupItems += this.processCategoryGroupItem(category, theme);
        }

        if (categoryGroupItems.length) {
          outputString += ns.fn.renderTemplate(
            {
              FilterCategoryGroupTheme: theme.Label,
              FilterCategoryGroupTechnology: '',
              FitlerCategoryGroupItems: categoryGroupItems,
            },
            templates.filterCategoryGroupTemplate
          );
        }
      }

      return outputString;
    },
    processCategoryGroupItem: function (category, theme) {
      let settings = this.settings,
        templates = settings.templates;

      category.CollapseClass = '';
      category.ThemeValue = theme.Value;
      let outputString = ns.fn.renderTemplate(category, templates.filterCategoryTemplate);
      if (category.Selected) {
        this.setCategoryOne(category.Value, category.Label);
        this.selectedCategoryOne = category.Value;
      }

      return outputString;
    },
    processFilterPart: function (filterData, selectedData, collapsed = false, baseId) {
      let settings = this.settings,
        templates = settings.templates,
        cache = settings.cache,
        events = settings.events;

      if (filterData.Options && filterData.Options.length) {
        filterData.RenderedOptions = '';
        filterData.Collapsed = collapsed ? 'mobile-hide' : '';
        filterData.ariastate = !collapsed ? 'aria-expanded="true"' : '';

        for (let i = 0; i < filterData.Options.length; i++) {
          filterData.Options[i].id = baseId + i;
          filterData.Options[i].selected = filterData.Options[i].Selected ? 'checked' : '';

          filterData.Options[i].disabledClass = filterData.Options[i].Disabled ? ' disabled' : '';

          if (filterData.Options[i].Image && filterData.Options[i].Image.length) {
            filterData.Options[i].LabelImage = '<i class="label-image" style="background-image: url(\'' + filterData.Options[i].Image + '\')"></i>';
          } else {
            filterData.Options[i].LabelImage = '';
          }
          filterData.RenderedOptions += ns.fn.renderTemplate(filterData.Options[i], templates.filterCheckboxTemplate);
        }
        filterData.ControlType = 'select';
        this.filterPartContainer.append(ns.fn.renderTemplate(filterData, templates.filterTemplate));
      } else if (filterData.Min !== null && filterData.Max !== null && filterData.Min !== '' && filterData.Max !== '') {
        if (filterData.SelectedMin && filterData.SelectedMin.length && filterData.SelectedMax && filterData.SelectedMax.length) {
          selectedData = [];
          selectedData[0] = filterData.SelectedMin;
          selectedData[1] = filterData.SelectedMax;
        }

        if (selectedData && selectedData.length && Array.isArray(selectedData) && selectedData.length === 2) {
          filterData.MinValue = selectedData[0];
          filterData.MaxValue = selectedData[1];
        } else {
          filterData.MinValue = filterData.Min;
          filterData.MaxValue = filterData.Max;
        }

        filterData.RenderedOptions = ns.fn.renderTemplate(filterData, templates.filterSliderTemplate);
        filterData.Collapsed = collapsed ? 'mobile-hide' : '';
        filterData.ariastate = !collapsed ? 'aria-expanded="true"' : '';
        filterData.ControlType = 'slider';

        let filterPart = $(ns.fn.renderTemplate(filterData, templates.filterTemplate));
        this.filterPartContainer.append(filterPart);

        let minValueElement = filterPart.find(cache.filterSliderMin);
        let maxValueElement = filterPart.find(cache.filterSliderMax);

        $(cache.filterSliderInput)
          .slider({
            step: 0.1,
          })
          .on(events.slide, (e) => {
            if (e.value.length === 2 && minValueElement && minValueElement.length && maxValueElement && maxValueElement.length) {
              minValueElement.text(e.value[0]);
              maxValueElement.text(e.value[1]);
            }
          });
      } else {
        return false;
      }
      return true;
    },
    processProducts: function (productData, isPartialUpdate) {
      let settings = this.settings,
        templates = settings.templates;

      return new Promise((resolve) => {
        let animationDelay = 0.2;
        // Is partial update (next page etc...) then don't empty the container
        if (!isPartialUpdate) {
          this.productContainer.html('');
        }
        if (!productData || !productData.length) {
          this.productContainer.append(templates.noResultsTemplate);
          resolve();
          return;
        }
        for (let i = 0; i < productData.length; i++) {
          productData[i].Category = productData[i].Tag ? productData[i].Tag : '';
          productData[i].CategoryClass = productData[i].Tag ? 'contains-tag' : '';

          productData[i].HasPrice = productData[i].Price ? '' : 'hide';

          productData[i].AnimationDelay = animationDelay;
          animationDelay += 0.1;
          this.productContainer.append(ns.fn.renderTemplate(productData[i], templates.productItemTemplate));
        }
        this.loadedProducts += productData.length;
        resolve();
      });
    },
    renderProductCategoriesPlaceholder: function (htmlData) {
      // inject HTML
      const documentToken = $(document.body).find('[name=__RequestVerificationToken]').val();

      this.productCategoriesPlaceholder.html(htmlData || '');
      const formToken = $(document.body).find('form [name=__RequestVerificationToken]');
      formToken.val(documentToken);

      // find JS modules to init
      ns.dataComponentInitializer(this.productCategoriesPlaceholder);

      // run any animation
      ns.Animation.init();

      // run async images
      ns.fn.asyncImageLoading();

      // check setion seperators
      ns.fn.checkSectionSeperators();

      // check for init of forms
      this.checkFormsInitialization();
    },
    startLoading: function () {
      let settings = this.settings,
        classes = settings.classes;

      this.container.addClass(classes.loading);
    },
    endLoading: function () {
      let settings = this.settings,
        classes = settings.classes;

      this.container.removeClass(classes.loading);
      this.productOverviewFooterDescription.removeClass(classes.hidden);
    },
    showError: function () {
      let settings = this.settings,
        templates = settings.templates;

      //this.productContainer.html('');
      this.productOverviewHeader.append(templates.badResultsTemplate);
      this.productOverviewHeader.show();
    },
    getCurrentFilterStatus: function () {
      this.getCurrentThemeStatus();
    },
    getCurrentThemeStatus: function () {
      let settings = this.settings,
        data = settings.data,
        cache = settings.cache;

      let themes = this.filterThemesContainer.find(cache.filterTheme);
      this.selectedThemes = '';
      for (let i = 0; i < themes.length; i++) {
        let theme = themes.eq(i);
        if (theme.attr('data-' + data.selected) === 'true') {
          this.selectedThemes = theme.data(data.value);
          return;
        }
      }
    },
    getCurrentCategoryOneStatus: function () {
      let settings = this.settings,
        data = settings.data,
        cache = settings.cache;

      let categories = this.filterCategoryContainer.find(cache.filterCategory);
      this.selectedCategoryOne = '';
      for (let i = 0; i < categories.length; i++) {
        let category = categories.eq(i);
        if (category.attr('data-' + data.selected) === 'true') {
          this.setCategoryOne(category.data(data.value), category.text());
          this.selectedThemes = category.data(data.themeValue);
          return;
        }
      }
      this.setCategoryOne('', '');
    },
    setCategoryOne: function (value, label) {
      this.selectedCategoryOne = value;

      this.filterActiveCategory.text(label);

      if (value === '') {
        this.filterIntroCategoryEllipsis.show();
        this.filterIntroSubCategory.hide();
        this.filterThemesContainer.show();
        this.selectedThemes = '';
      } else {
        this.filterIntroCategoryEllipsis.hide();
        this.filterIntroSubCategory.show();
        this.filterThemesContainer.hide();
      }
    },
    getCurrentCategoryTwoStatus: function () {
      let settings = this.settings,
        data = settings.data,
        cache = settings.cache;

      let categories = this.filterSubCategoryContainer.find(cache.filterSubCategory);
      this.selectedCategoryTwo = '';
      for (let i = 0; i < categories.length; i++) {
        let category = categories.eq(i);
        if (category.attr('data-' + data.selected) === 'true') {
          this.setCategoryTwo(category.data(data.value), category.text());
          return;
        }
      }
      this.setCategoryTwo('', '');
    },
    getFilterStatus: function () {
      this.selectedFilters = [];

      let filterBodies = this.filterPartContainer.find('[data-filter-type^=filter]');
      for (let i = 0; i < filterBodies.length; i++) {
        const filterBody = filterBodies.eq(i);

        const filterKey = filterBody.data('filter-type');
        this.selectedFilters[filterKey] = this.getFilterPartStatus(filterBody);
      }
    },
    getFilterPartStatus: function (filterBody) {
      let settings = this.settings,
        cache = settings.cache;

      let slider = filterBody.find(cache.filterSliderInput);
      // Check if slider filter
      if (slider && slider.length) {
        // Is slider filter, take value of the input;
        return slider.val();
      } else {
        // Is option filter probably, take checked boxes;
        let checkedCheckboxes = filterBody.find(cache.input + ':checked'),
          checkedValues = [];

        for (let i = 0; i < checkedCheckboxes.length; i++) {
          checkedValues.push(checkedCheckboxes.eq(i).val());
        }

        return checkedValues;
      }
    },
    setCategoryTwo: function (value, label) {
      this.selectedCategoryTwo = value;
      this.filterActiveSubCategory.text(label);
      if (value === '') {
        this.filterIntroSubCategoryEllipsis.show();
      } else {
        this.filterIntroSubCategoryEllipsis.hide();
      }
    },
    clearFilterPart: function () {
      let settings = this.settings,
        cache = settings.cache;

      let slider = this.filterPartContainer.find(cache.filterSliderInput);

      let value = [parseFloat(slider.data('slider-min')), parseFloat(slider.data('slider-max'))];
      slider.slider('setValue', value);

      let currentCheckboxes = this.filterPartContainer.find(cache.filterCheckbox).find(cache.checked);

      currentCheckboxes.prop('checked', false);

      this.selectedFilters = [];

      // Set filters dirty false as filters have been cleared
      this.isFiltersDirty = false;
    },
    updateUrl: function (url, newTitle) {
      if (!url || !url.length) {
        return;
      }

      if (!newTitle) {
        newTitle = '';
      }

      if (url.length === 1) {
        url = this.baseUrl + '';
      }

      if (url[0] === '?') {
        url = this.baseUrl + url;
      }

      if (location.pathname + location.search !== url) {
        history.pushState(
          {
            urlParams: url,
          },
          newTitle,
          url
        );
      }

      document.title = newTitle;
    },
    loadMore: function () {
      this.currentPage++;

      let url = this.apiUrl,
        urlParams = this.buildUrlParams();

      if (urlParams.length) {
        url += '?' + urlParams;
      }

      const data = this.localCache[url];

      // TO DO BrowserTitle
      this.updateUrl('?' + urlParams, '');

      this.doUpdate(true, false, urlParams);
    },
    toggleShowMore: function () {
      if (this.totalProducts > this.loadedProducts) {
        this.btnLoadMore.show();
      } else {
        this.btnLoadMore.hide();
      }
    },
    persistCollapseState: function () {
      let settings = this.settings,
        cache = settings.cache,
        classes = settings.classes;

      let filterBodies = this.filterPartContainer.find(cache.filterBody);
      this.filterCollapseState = [];
      for (let i = 0; i < filterBodies.length; i++) {
        this.filterCollapseState[i] = filterBodies.eq(i).hasClass(classes.mobileHide);
      }
    },
    cleanHeightCategoryContainer: function () {
      // Reset height and padding to take needed ones
      this.filterCategoryContainer.css('height', '');
      this.filterCategoryContainer.css('padding', '');
    },

    checkFormsInitialization: function () {
      let settings = this.settings,
        data = settings.data,
        cache = settings.cache;

      if ($(cache.sitecoreForm).length) {
        let create = (info) => {
          return new Promise(function (resolve, reject) {
            let gfgData = document.createElement('script');
            gfgData.src = info;
            gfgData.async = false;
            gfgData.onload = () => {
              resolve(info);
            };
            gfgData.onerror = () => {
              reject(info);
            };
            document.body.appendChild(gfgData);
          });
        };

        let promiseData = [];
        data.formScripts.forEach((info) => {
          if (!this.isLoadedScript(info)) {
            promiseData.push(create(info));
          }
        });
        Promise.all(promiseData)
          .then(function () {
            console.log('Form scripts are loaded');
          })
          .catch(function (gfgData) {
            console.log(gfgData + ' failed to load!');
          });
      }
    },

    isLoadedScript: function (lib) {
      return document.querySelectorAll('[src="' + lib + '"]').length > 0;
    },
  };

  return ns;
})(window.jQuery, window.Dom || {}, window._ || {});
